import { render, staticRenderFns } from "./EbmFooter.vue?vue&type=template&id=48bb3bf0&scoped=true"
import script from "./EbmFooter.vue?vue&type=script&lang=js"
export * from "./EbmFooter.vue?vue&type=script&lang=js"
import style0 from "./EbmFooter.vue?vue&type=style&index=0&id=48bb3bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb3bf0",
  null
  
)

export default component.exports